import { CodeSystem } from "context/elasticsearch/types";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

export default function useCodeNavigate() {
  const navigate = useNavigate();

  const toCode = useCallback(
    (codeSystem: CodeSystem, codeValue?: string) => {
      const basePath =
        codeSystem === CodeSystem.Adm
          ? `/${codeSystem}/collections`
          : `/${codeSystem}/chapter`;

      navigate(
        codeValue ? `${basePath}/${encodeURIComponent(codeValue)}` : basePath
      );
    },
    [navigate]
  );

  const toSearch = useCallback(
    (codeSystem: CodeSystem) => {
      navigate(`/${codeSystem}/search`);
    },
    [navigate]
  );

  const toHistory = useCallback(
    (codeSystem: CodeSystem) => {
      navigate(`/${codeSystem}/history`);
    },
    [navigate]
  );

  return useMemo(
    () => ({
      toCode,
      toSearch,
      toHistory
    }),
    [toCode, toSearch, toHistory]
  );
}
